import React, { ComponentProps } from 'react';

import { CategoriesList } from '../partials/CategoriesList';
import { CategoryElement } from '../partials/CategoryElement';
import { CategoryDefault } from '../categoriesTypes';
import { CategoriesListItem } from '../partials/CategoriesListItem';
import { asFetchableView } from '../../../_lib/ViewFetcher';

export type CategoriesDefaultViewProps = {
  categories: CategoryDefault[];
};

/**
 * DefaultView for the [x]CategoriesBlock
 * renders only the categories in the children list
 */
export function CategoriesDefault({ categories }: CategoriesDefaultViewProps) {
  return (
    <CategoriesList categories={categories}>
      {({ title, image, hexColor, id, maxValidityPeriodDays }) => (
        <CategoriesListItem key={id} style={{ borderLeftColor: hexColor }}>
          <CategoryElement key={title} title={title} maxValidityPeriodDays={maxValidityPeriodDays} image={image} />
        </CategoriesListItem>
      )}
    </CategoriesList>
  );
}

export const CategoriesDefaultView = asFetchableView(CategoriesDefault);
export type CategoriesDefaultView = ComponentProps<typeof CategoriesDefaultView>;
